import React from 'react';
import styled from 'styled-components';
import { config } from '@keytrade/functions';
import { Icon } from '@keytrade/components-icon';

import useTranslations from '@/hooks/useTranslations';

import CostumFilterCheckbox from './CostumFilterCheckbox';
import SaveFilter from './SaveFilter';

const { list: colors } = config.colors;
const { getFont } = config.fonts;

const SubPanel = styled.div`
  position: absolute;
  right: calc(100% - 52px);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: calc(100% - 52px);
  height: 100%;
  overflow: auto;
  background-color: ${colors.White};
  z-index: 99;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08),
    0px 12px 20px 0px rgba(0, 0, 0, 0.14);
  transform: translateX(100%);
  transition: transform 0.2s, box-shadow 0.2s cubic-bezier(0.23, 1, 0.32, 1);
`;

const SubPanelWrapper = styled.div``;

const SubPanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px 24px 25px;
  border-bottom: 2px solid ${colors.BlueLight};
`;

const SubPanelHeaderInformation = styled.div`
  display: flex;
  align-items: center;
`;

const FilterTitle = styled.span`
  margin-left: 20px;
  font-size: 16px;
  line-height: 24px;
  font-family: ${({ theme }) => getFont(theme, 'bold')};
  color: ${colors.BlueDark};
`;

const SubFilterClear = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-family: ${({ theme }) => getFont(theme, 'regular')};
  color: ${colors.GreyBlue};
`;

const SubPanelFilters = styled.div`
  display: flex;
  flex-direction: column;
`;
export type SubPanelData = {
  filterOptions: Array<any>;
  closeSubPanel: () => void;
  onChangeHandler: () => void;
  isSelected: (value: string) => boolean;
  clearFilter: () => void;
  closePanel: () => void;
  filterName: string;
  category: string;
};

type Props = SubPanelData;
const MobileSubPanelFilters: React.FC<Props> = ({
  filterOptions,
  closeSubPanel,
  onChangeHandler,
  isSelected,
  clearFilter,
  closePanel,
  filterName,
  category,
}) => {
  const { t } = useTranslations();

  return (
    <SubPanel>
      <SubPanelWrapper>
        <SubPanelHeader>
          <SubPanelHeaderInformation onClick={closeSubPanel}>
            <Icon
              icon='icn_longArrowLeft'
              size='20px'
              color={`${colors.BlueDark}`}
            />
            <FilterTitle>
              {category === 'media'
                ? t(`${category}.filters.${filterName}`)
                : t(`${category}.${filterName}_label`)}
            </FilterTitle>
          </SubPanelHeaderInformation>
          <SubFilterClear onClick={clearFilter}>
            {t('filter.clear')}
          </SubFilterClear>
        </SubPanelHeader>
        <SubPanelFilters>
          {React.Children.toArray(
            filterOptions.map((filter) => {
              return CostumFilterCheckbox({
                value: filter.value,
                label: filter.label,
                onChange: onChangeHandler,
                isSelected: isSelected(filter.value),
              });
            }),
          )}
        </SubPanelFilters>
      </SubPanelWrapper>
      <SaveFilter closeFilterPanel={closePanel} />
    </SubPanel>
  );
};

export default MobileSubPanelFilters;
